import React from 'react';
import {Box, Button, Divider, Grid, makeStyles, Typography} from '@material-ui/core';
import clsx from "clsx";
import {Field, Form} from "react-final-form";
import FinalFormTextField from "../../../../../../../../atoms/FinalFormTextField";
import Validation, {translate} from "../../../../../../../../../state/utils/Validation";
import arrayMutators from 'final-form-arrays'
import globalTheme from "../../../../../../../../theme/globalTheme";
import {empty} from "../../../../../../../../../state/utils/Common";
import FinalFormTextArea from "../../../../../../../../atoms/FinalFormTextArea";


const inputTypes = {
    'text': FinalFormTextField,
    'textarea': FinalFormTextArea
}

/**
 * /manager/notices コンテンツスタイル
 */
const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2)
    },
    button: {
        fontWeight: 900,
    },
    strong: {
        fontWeight: "bold"
    }
}));
/**
 *
 * /noticesのメインコンポーネント
 * @param managerLoadNoticeList
 * @param {*} t - 翻訳
 * @returns {JSX.Element}
 * @constructor
 */
const AdditionalSteps = (
    {
        additionalOptionInformation,
        settingAdditionalSteps,
        additionalOptionValidation,
        additionalFieldsArray,
        settingEbisBackButton,
        quoteId,
        requestId,
        t
    }) => {
    const classes = useStyles();
    const formClasses = globalTheme.defaultFormStyle();
    return (
        <>
            <Box className={clsx(classes.root)}>
                <Typography variant="body1">{t('requests.detail.quotes.setting.step_1_ebis.description')}</Typography>
            </Box>
            <Box className={clsx(classes.root)}>
                <Form
                    onSubmit={e => {
                        console.log(e);
                        settingAdditionalSteps(e)
                    }}
                    mutators={{
                        ...arrayMutators
                    }}
                    // ここでフォームデータを妥当性確認し、キーを変換します。
                    validate={e => {
                        return translate(t, Validation({...e}, additionalOptionValidation))
                    }}
                    // （編集モード）最初のバリュー
                    initialValues={additionalOptionInformation}
                    // ここでは、フォームのレンダリングと制御を行います
                    // エラー処理やダブルクリック防止などはここで行います
                    render={({
                                 handleSubmit,
                                 form: {
                                     mutators: {push, pop}
                                 },
                                 submitting,
                                 pristine,
                                 invalid,
                                 values
                             }) => (
                        <form onSubmit={handleSubmit} noValidate>
                            {!empty(additionalFieldsArray) && additionalFieldsArray.map((value) => {
                                return (
                                    <div>
                                        <h2>{value.label}</h2>
                                        {value.fields.map((value) => {
                                            return (<Grid container alignItems="flex-start" spacing={2}>
                                                <Grid item md={3}>
                                                    <Grid container>
                                                        <Grid item xs={11}>
                                                            <Field
                                                                fullWidth
                                                                size={"small"}
                                                                required={value.required}
                                                                label={t(value.label)}
                                                                name={value.name}
                                                                component={inputTypes[value.input]}
                                                                type="text"
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    {!empty(value?.hint) &&
                                                    <Grid container>
                                                        <Grid item xs={12}>
                                                            <Typography style={{paddingTop: 5}}
                                                                        variant={"subtitle1"}>{t('requests.detail.quotes.setting.step_1_ebis.id_hint')}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    }
                                                </Grid>
                                            </Grid>);
                                        })}
                                        <Divider style={{marginTop: 15, marginBottom: 15}} />
                                    </div>
                                )
                            })}
                            <Box className={clsx(classes.root)} marginY={1} alignContent="middle">
                                <Grid container justify="center" alignItems={"center"} spacing={5}>
                                    <Button
                                        variant={"contained"}
                                        color={"secondary"}
                                        style={{marginRight: 20, fontWeight: 900}}
                                        onClick={() => settingEbisBackButton()}
                                    >
                                        {t('actions.back')}
                                    </Button>
                                    <Button variant={"contained"} style={{fontWeight: 900}}
                                            color={"primary"}
                                            type="submit"
                                            disabled={invalid}
                                    >
                                        {t('actions.next')}
                                    </Button>
                                </Grid>
                            </Box>
                        </form>)}/>
            </Box>
        </>
    );
}

export default AdditionalSteps;
